
import { i18nText } from '@/locales';

    import { Component } from "vue-property-decorator";
    import { Modal, Select } from "ant-design-vue";
    import { mixins } from "vue-class-component";

    import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
    import { VisitsStore } from "@/store/modules/Visits";
    import { StatusMix } from "@/UI/pages/visitsNew/mixins/StatusMix";
    import { UtilsMix } from "@/UI/pages/visitsNew/mixins/UtilsMix";
    import { LoyaltyCertFormData } from "@/form/loyalty/loyaltyCert/LoyaltyCert";
    import { LoyaltyCertTypeStore } from "@/store/modules/Loyalty/Cert/LoyaltyCertType";
    import { LoyaltyCertTypesMix } from "@/UI/mixins/Loaylty/LoyaltyCertTypesMix";
    import { getStudioId } from "@/UI/lib/state";
    import { AppFormsStore } from "@/store/modules/appForms";
    import { SearchMix } from "@/UI/pages/visitsNew/mixins/SearchMix";

    @Component({
        components: {
            "a-modal": Modal,
            "a-select": Select,
            "a-select-option": Select.Option,
        },
    })
    export default class DebtForm extends mixins(
        LoyaltyCertTypesMix,
        SimpleProxyForm,
        StatusMix,
        UtilsMix,
        SearchMix,
    ) {
        showModal: boolean = false;
        vData: any[] = [];
        id = this.$router.currentRoute.params["id"];

        addCode(): void {
            this.formCerificate = new LoyaltyCertFormData();
        }

        async addCertificatesInBox(): Promise<void> {
            const certId = String(this.formCerificate?.type_id);
            if (certId) {
                await LoyaltyCertTypeStore.fetchData({ filter: { id: certId } });
                if (this.loyaltyCertTypeItem) {
                    let data: Record<any, any> = {
                        type: "certificate",
                        name: i18nText("Сертификат №") + this.formCerificate.code,
                        data: { type_id: this.formCerificate.type_id, code: this.formCerificate.code },
                        created: 1,
                        balance: this.loyaltyCertTypeItem.balance,
                        discount: 0,
                        total: this.loyaltyCertTypeItem.balance,
                    };

                    //await this.pushToBox(data);
                    AppFormsStore.addData(data);
                    this.formCerificate = new LoyaltyCertFormData();
                }
            }
console.warn(this.boxData)
        }
        async modalCancel(): Promise<void> {
            this.showModal = false;
            await this.backToRoute(1);
        }
        async modalOk(): Promise<void> {
            this.showModal = false;
            await this.addCertificatesInBox();
            await this.backToRoute(1);
        }
        async mounted(): Promise<void> {
            try {
                this.formReady = false;
                await this.getData();
            } finally {
                await this.setShow();
                this.formReady = true;
            }
        }
        async getData(): Promise<void> {
            await LoyaltyCertTypeStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
            // this.client.visits.map(async (visit: any) => {
            //     await VisitsStore.fetchData({ filter: { id: visit["id"] } });
            //     this.vData.push(this.visit);
            // })
        }

        async setShow(): Promise<void> {
            this.showModal = true;
        }
        async created(): Promise<void> {}
    }
